import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        component: () => import("@/components/page-layouts/Auth.vue"),
        children: [
            {
                path: "/sign-in",
                name: "sign-in",
                meta: { title: "Login" },
                component: () => import("@/views/authentication/basic-flow/SignIn.vue"),
            },
            {
                path: "/password-reset",
                name: "password-reset",
                meta: { title: "Passwort zurücksetzen" },
                component: () => import("@/views/authentication/basic-flow/PasswordReset.vue"),
            },
            {
                path: "/new-password/:token/:pEmail",
                name: "NewPassword",
                meta: { title: "Passwort zurücksetzen" },
                component: () => import("@/views/authentication/basic-flow/NewPassword.vue"),
                props: true,
            },
        ],
    },
    {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/authentication/Error404.vue"),
    },
    {
        path: "/500",
        name: "500",
        component: () => import("@/views/authentication/Error500.vue"),
    },
];

export default routes;
